import React from "react";
import { Outlet } from "react-router-dom";
import MFooterNavigation from "../ui/atoms/MFooterNavigation";

/**
 * BaseLayout: Used for 3rd Level Screens.
 * Renders main content with optional footer navigation
 *
 * @param {boolean} [showFooter=false] - Whether to show the footer navigation
 */
interface BaseLayoutProps extends React.PropsWithChildren {
  showFooter?: boolean;
}

const BaseLayout: React.FC<BaseLayoutProps> = ({
  children,
  showFooter = false,
}) => {
  return (
    <div className="flex flex-col h-[100dvh]">
      <main
        className="flex-1 overflow-y-auto overflow-x-hidden"
        style={{ height: showFooter ? "calc(100dvh - 80px)" : "100dvh" }}
      >
        {children ? children : <Outlet />}
      </main>
      {showFooter && <MFooterNavigation />}
    </div>
  );
};

export default BaseLayout;
